import { Component, OnInit, AfterViewInit } from "@angular/core";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolSettingsService } from "../services/adminsettings.service";
import { HttpclientService } from "../../../shared/services/httpclient.service";
import { UserService } from "../../../shared/services/user.service";
import { ConfirmationService, LazyLoadEvent } from "primeng/api";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";

@Component({
	templateUrl: "./suspensionsettings.component.html",
	styleUrls: ["../adminsettings.css"],
	providers: [ConfirmationService],
})
export class SuspensionSettingsComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private userService: UserService,
		private schoolSettingsService: SchoolSettingsService,
		private httpclientService: HttpclientService,
		private confirmationService: ConfirmationService
	) {}

	suspensionData = {
		SchoolID: 0,
		DefaultDuration: 1,
		ClassCuts: 0,
		BeforeDate: new Date(2000, 0, 1),
		StartAfterDays: 0,
		Indefinite: false,
		RosterUpdate: false,
	};
	user: any;
	errorMessage: any = "";
	isProcessing: any = false;
	durationList = [];
	cutsList = [];
	startAfterList = [];
	schoolList: any = [];
	preferenceList: any = [];

	subscription: any;
	loading: any = false;

	ngOnInit() {
		for (var i = 1; i <= 120; i++) {
			this.durationList.push({
				Duration: i,
			});
		}

		for (var i = 0; i <= 100; i++) {
			this.cutsList.push({
				ClassCuts: i,
			});
		}

		for (var i = 0; i <= 14; i++) {
			this.startAfterList.push({
				StartAfterDays: i,
			});
		}

		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.suspensionData.SchoolID = value;
		this.loadPreferences();
	}

	private loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.schoolList = response;
				this.suspensionData.SchoolID = this.schoolList[0].SchoolID;
			},
			(error) => {}
		);
	}

	private loadPreferences() {
		this.loading = true;

		var result = this.schoolSettingsService.loadPreferenceListByCategory(this.suspensionData.SchoolID, "Suspension");
		result.subscribe(
			(response) => {
				this.preferenceList = response;
				if (this.preferenceList.length <= 1) {
					this.resetVals();
				}
				//Update values
				for (var i = 0; i < this.preferenceList.length; i++) {
					var next = this.preferenceList[i];
					var name = next.KeyName;

					if (name == "NumCuts") {
						if (next.KeyValue == "N/A" || next.KeyValue < 0) {
							this.suspensionData.ClassCuts = 0;
						} else {
							this.suspensionData.ClassCuts = Number(next.KeyValue);
						}
					} else if (name == "NumDays") {
						if (Number(next.KeyValue) == -1) {
							this.suspensionData.Indefinite = true;
							this.suspensionData.DefaultDuration = 1;
						} else {
							this.suspensionData.DefaultDuration = Number(next.KeyValue);
						}
					} else if (name == "NumDaysAfter") {
						this.suspensionData.StartAfterDays = Number(next.KeyValue);
					} else if (name == "EnableDCR") {
						this.suspensionData.RosterUpdate = Number(next.KeyValue) == 1 ? true : false;
					}
				}

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	resetVals() {
		this.suspensionData.DefaultDuration = 1;
		this.suspensionData.ClassCuts = 0;
		this.suspensionData.StartAfterDays = 0;
		this.suspensionData.Indefinite = false;
		this.suspensionData.RosterUpdate = false;
	}

	resetIncidents() {
		////////////////////////SET Button
	}

	updateSuspensionSettings() {
		//ERR Handling
		if (!(this.suspensionData.SchoolID > 0)) {
			this.errorMessage = "Select a School";
			return;
		}

		//Update Each Prefrence

		//Suspension days
		//Check Indefinite (Set to -1)
		if (this.suspensionData.Indefinite) {
			var result = this.schoolSettingsService.updatePreference(this.suspensionData.SchoolID, "Suspension", "NumDays", -1);
			result.subscribe(
				(response) => {},
				(error) => {}
			);
		} else {
			var result = this.schoolSettingsService.updatePreference(
				this.suspensionData.SchoolID,
				"Suspension",
				"NumDays",
				this.suspensionData.DefaultDuration
			);
			result.subscribe(
				(response) => {},
				(error) => {}
			);
		}

		//Days After
		var result = this.schoolSettingsService.updatePreference(
			this.suspensionData.SchoolID,
			"Suspension",
			"NumDaysAfter",
			this.suspensionData.StartAfterDays
		);
		result.subscribe(
			(response) => {},
			(error) => {}
		);

		//Number of class cuts
		var result = this.schoolSettingsService.updatePreference(this.suspensionData.SchoolID, "Suspension", "NumCuts", this.suspensionData.ClassCuts);
		result.subscribe(
			(response) => {},
			(error) => {}
		);

		var cr = this.suspensionData.RosterUpdate ? 1 : 0;
		//Class Roster
		var result = this.schoolSettingsService.updatePreference(this.suspensionData.SchoolID, "Suspension", "EnableDCR", cr);
		result.subscribe(
			(response) => {},
			(error) => {}
		);

		//Success Dialog
		this.confirmationService.confirm({
			acceptLabel: "Ok",
			rejectVisible: false,
			message: "Suspension Settings were Successfully Updated",
			header: "Suspension Settings",
			icon: "fa",
			accept: () => {},
		});
	}
}
